import React from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

import Typography from 'src/components/ui/Typography';
import ExpandableText from 'src/components/ui/ExpandableText';

import formatDistanceToNow from 'src/utils/formatDistanceToNow';
import { styledComponent } from 'src/utils/styled';

const StyledCardContent = styledComponent(CardContent)`
    position: relative;
    padding: 1.5rem 0;
`;

export interface Props {
    description?: string;
    createdAt?: string;
}

const CompanyAboutSection: React.FC<Props> = ({ description, createdAt }) => {
    const { t, i18n } = useTranslation(['profile', 'common']);
    return (
        <Card elevation={0}>
            <StyledCardContent>
                <Typography variant="h2" serif>
                    {t('profile:about')}
                </Typography>
                <Box pt={createdAt ? 0 : 3} marginTop="1rem" data-target-id="companyAboutSection-description">
                    {description ? (
                        <ExpandableText text={description} lines={5} renderLineBreaksWhenClosed />
                    ) : (
                        <Typography>{t('common:general.noDescription')}</Typography>
                    )}
                </Box>
                {createdAt && (
                    <Box display="flex" alignItems="center" marginTop="1rem" data-target-id="companyAboutSection-date">
                        <Typography
                            color="dark"
                            dangerouslySetInnerHTML={{
                                __html: t('profile:registeredSince', {
                                    highlight: formatDistanceToNow(createdAt, i18n.language as SupportedLangs),
                                }),
                            }}
                        />
                    </Box>
                )}
            </StyledCardContent>
        </Card>
    );
};

export default CompanyAboutSection;
